import { render } from "./adjust-score.vue?vue&type=template&id=dd8f409e&scoped=true&ts=true"
import script from "./adjust-score.vue?vue&type=script&lang=tsx"
export * from "./adjust-score.vue?vue&type=script&lang=tsx"

import "./adjust-score.vue?vue&type=style&index=0&id=dd8f409e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8f409e"]])

export default __exports__